<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('MediaUploadrecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="formInline.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('userNameH')" v-if="!userId">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fileType')">
            <el-select v-model="formInline.type" clearable :placeholder="$t('fileType')" :popper-append-to-body="false">
              <el-option v-for="item of fileType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('appName')">
            <el-input v-model="formInline.appName" clearable :placeholder="$t('appName')"></el-input>
          </el-form-item>
          
          <el-form-item :label="$t('startDate')" class="datetime">
            <el-date-picker
              v-model="formInline.logDateBegin"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.logDateEnd"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP')">
            <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button
              type="primary"
              class="serachBtn letter_delet"
              @click="handleDelet"
              v-preventReClick="1000"
              v-has="'sys:new:setting:log:data:delete'"
              >{{ $t('batchDelete') }}</el-button
            >
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="total-flow">
        <span
          >{{ $t('allFileSize') }}：<i class="log-num">{{ statisData.sum_of_file_size }}</i></span
        >
        <span
          >{{ $t('avgFileSize') }}：<i class="log-num">{{ statisData.avg_of_file_size }}</i></span
        >
        <span
          >{{ $t('allFileUploadSpeed') }}：<i class="log-num">{{ statisData.avg_of_upload_speed }}</i></span
        >
        <span
          >{{ $t('voiceFile') }}：<i class="log-num">{{ statisData.count_of_audio }}</i></span
        >
        <span
          >{{ $t('videoFile') }}：<i class="log-num">{{ statisData.count_of_video }}</i></span
        >
        <span
          >{{ $t('photoFile') }}：<i class="log-num">{{ statisData.count_of_picture }}</i></span
        >
      </div>
      <!-- table 表格 -->

      <div class="table-box">
        <Table
          v-loading="loading"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :type="type"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
          :operationWidth="100"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/NewTable'
import { mediaUploadInfo, deleteMediaUploadInfoLog, mediaUploadAppNames, mediaUploadInfoStatistics } from '@/api/log'
import { getOus } from '@/api/UserList'
import { getExportMediaUpload } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  // 实时监控》历史记录》组件弹窗传用户名
  props: {
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      // 表单查询字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        appName: '',
        logDateBegin: beforeWeekDate(),
        logDateEnd: nowDate(),
        type: '',
      },
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      // 查询 ‘所有文件’的类型
      fileType: [
        { value: '0', label: this.$t('voice') },
        { value: '1', label: this.$t('video') },
        { value: '2 ', label: this.$t('picture') },
      ],
      // 查询 ’应用程序‘的数据
      appNames: [],
      // 媒体文件 总数（大小G）
      statisData: {},
      // 用于批量删除 公共组件类型判断
      type: 'mediaUpload',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        type: this.formInline.type,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportMediaUpload(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('MediaUploadrecord') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.deleteMediaUpload(row)
      }
    },
    // 删除媒体上传日志
    deleteMediaUpload(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteMediaUploadInfoLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.logDateBegin, this.formInline.logDateEnd)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        type: this.formInline.type,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      mediaUploadInfo(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // 获取媒体内存大小 上传速度 数据
      mediaUploadInfoStatistics(param).then(res => {
        if (res.state === 0) {
          this.statisData = res.value
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'fileName',
          label: this.$t('fileName'),
          sort: 'fileName',
        },
        {
          attrName: 'typeStr',
          label: this.$t('fileType'),
          align: 'center',
          width: '100',
          sort: 'typeStr',
        },
        {
          attrName: 'fileSize',
          label: this.$t('fileSize'),
          align: 'right',
          width: '100',
          sort: 'fileSize',
        },
        {
          attrName: 'startUploadTime',
          label: this.$t('startUploadTime'),
          width: '180',
          align: 'center',
          sort: 'startUploadTime',
        },
        {
          attrName: 'endUploadTime',
          label: this.$t('endUploadTime'),
          width: '180',
          align: 'center',
          sort: 'endUploadTime',
        },
        {
          attrName: 'uploadSpeed',
          label: this.$t('uploadSpeed'),
          align: 'right',
          width: '140',
          sort: 'uploadSpeed',
        },
        {
          attrName: 'wifiName',
          label: this.$t('wifiName'),
          sort: 'wifiName',
        },
        {
          attrName: 'appName',
          label: this.$t('appName'),
          align: 'center',
          width: '120',
          sort: 'appName',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 查询获取媒体上传appNameList
    getAppNames() {
      mediaUploadAppNames().then(res => {
        if (res.state === 0) {
          this.appNames = []
          for (let i = 0; i < res.value.length; i++) {
            this.appNames.push({ value: res.value[i], label: res.value[i] })
          }
        }
      })
    },
  },
  created() {
    this.basicConfig()
    this.getAppNames()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';
.demo-form-inline
  *zoom: 1
  &:before,&:after
    display: table
    content: ""
    clear: both

.total-flow {
  margin-bottom: 0px;
  line-height: 36px;
  background: #f0f9ff;
  border: 1px solid var(--border-grey);
  border-bottom: none;

  span {
    margin-left: 10px;
    font-weight: 600;

    &:first-child {
      margin-left: 20px;
    }
  }
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)

>>>.el-popper {
  min-width: 200px !important;
}

.letter_delet {
  margin-left: 10px;
}

// 深色
.theme-dark {
  .total-flow {
    background: #072368;
    border: 1px solid #0057A8;
  }
}

.bg-contain .common-table-cnt:has(.total-flow) /deep/ .el-table {
  height: 540px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
</style>
